import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Link } from 'react-router';

class Breadcrumbs extends React.Component {
  breadcrumbLinks() {
    return this.props.breadcrumbs.map((breadcrumb, i) => {
      if (breadcrumb.clientSide) {
        return (
          <Link
            key={i}
            className="navigation-breadcrumbs__link"
            to={breadcrumb.url}
          >
            {breadcrumb.name}
          </Link>
        );
      }

      return (
        <a
          key={i}
          className="navigation-breadcrumbs__link"
          href={breadcrumb.url}
        >
          {breadcrumb.name}
        </a>
      );
    });
  }

  render() {
    return <div className="navigation-breadcrumbs">{this.breadcrumbLinks()}</div>;
  }
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/breadcrumbs.jsx